import { ThemeColors } from './theme.types';

export const lightColors: ThemeColors = {
  // Podstawowe
  primary: '#4F46E5',
  primaryHover: '#4338CA',
  primaryActive: '#3730A3',
  primaryLight: '#EEF2FF',
  primaryDark: '#3730A3',

  // Tła
  background: '#f5f5f5',
  backgroundSecondary: '#fafafa',
  backgroundTertiary: '#f0f0f0',
  backgroundHover: 'rgba(0, 0, 0, 0.04)',

  // Surface
  surface: '#ffffff',
  surfaceHover: '#fafafa',
  surfaceBorder: '#e5e7eb',

  // Tekst
  text: '#1a1a1a',
  textSecondary: '#6c757d',
  textTertiary: '#adb5bd',
  textInverse: '#ffffff',
  textDisabled: '#adb5bd',

  // Status - Success
  success: '#52c41a',
  successBg: 'rgba(82, 196, 26, 0.15)',
  successHover: '#059669',
  successLight: '#d1fae5',
  successLighter: '#a7f3d0',
  successDark: '#047857',

  // Status - Error
  error: '#ff4d4f',
  errorBg: 'rgba(255, 77, 79, 0.15)',
  errorHover: '#b91c1c',
  errorLight: '#fef2f2',
  errorLighter: '#fecaca',
  errorDark: '#991b1b',
  errorBorder: '#ef4444',

  // Status - Warning
  warning: '#faad14',
  warningBg: 'rgba(250, 173, 20, 0.15)',
  warningHover: '#d97706',
  warningLight: '#fef3c7',
  warningDark: '#b45309',

  // Status - Info
  info: '#1890ff',
  infoBg: 'rgba(24, 144, 255, 0.15)',
  infoLight: '#e6f7ff',
  infoDark: '#096dd9',

  // Gradienty
  gradientStart: '#4F46E5',
  gradientEnd: '#7C3AED',

  // Cienie
  shadow: 'rgba(0, 0, 0, 0.1)',
  shadowLight: 'rgba(0, 0, 0, 0.05)',

  // Bordy
  border: '#d9d9d9',
  borderLight: '#e9ecef',
  borderDark: '#d9d9d9',
  borderInput: '#e9ecef',
  borderHover: '#d1d5db',
  divider: '#f0f0f0',

  // Overlay
  overlay: 'rgba(0, 0, 0, 0.1)',
  overlayDark: 'rgba(0, 0, 0, 0.2)',

  // Gray scale
  gray50: '#f9fafb',
  gray100: '#f3f4f6',
  gray200: '#e5e7eb',
  gray300: '#d1d5db',
  gray400: '#9ca3af',
  gray500: '#6b7280',
  gray600: '#4b5563',
  gray700: '#374151',
  gray800: '#1f2937',
  gray900: '#111827',

  // Input
  inputDisabled: '#f5f5f5',
};

export const darkColors: ThemeColors = {
  // Podstawowe
  primary: '#818cf8',
  primaryHover: '#a5b4fc',
  primaryActive: '#6366f1',
  primaryLight: '#1e1b4b',
  primaryDark: '#c7d2fe',

  // Tła
  background: '#0f0f0f',
  backgroundSecondary: '#1a1a1a',
  backgroundTertiary: '#262626',
  backgroundHover: 'rgba(255, 255, 255, 0.06)',

  // Surface
  surface: '#1f1f1f',
  surfaceHover: '#2a2a2a',
  surfaceBorder: '#404040',

  // Tekst
  text: '#f5f5f5',
  textSecondary: '#a0a0a0',
  textTertiary: '#6b6b6b',
  textInverse: '#1a1a1a',
  textDisabled: '#555555',

  // Status - Success
  success: '#4ade80',
  successBg: 'rgba(74, 222, 128, 0.2)',
  successHover: '#34d399',
  successLight: '#064e3b',
  successLighter: '#065f46',
  successDark: '#86efac',

  // Status - Error
  error: '#f87171',
  errorBg: 'rgba(248, 113, 113, 0.2)',
  errorHover: '#fca5a5',
  errorLight: '#450a0a',
  errorLighter: '#7f1d1d',
  errorDark: '#fecaca',
  errorBorder: '#f87171',

  // Status - Warning
  warning: '#fbbf24',
  warningBg: 'rgba(251, 191, 36, 0.2)',
  warningHover: '#fcd34d',
  warningLight: '#451a03',
  warningDark: '#fde68a',

  // Status - Info
  info: '#60a5fa',
  infoBg: 'rgba(96, 165, 250, 0.2)',
  infoLight: '#1e3a5f',
  infoDark: '#93c5fd',

  // Gradienty
  gradientStart: '#4338ca',
  gradientEnd: '#6d28d9',

  // Cienie
  shadow: 'rgba(0, 0, 0, 0.5)',
  shadowLight: 'rgba(0, 0, 0, 0.3)',

  // Bordy
  border: '#404040',
  borderLight: '#333333',
  borderDark: '#555555',
  borderInput: '#404040',
  borderHover: '#555555',
  divider: '#2a2a2a',

  // Overlay
  overlay: 'rgba(255, 255, 255, 0.06)',
  overlayDark: 'rgba(0, 0, 0, 0.4)',

  // Gray scale
  gray50: '#1a1a1a',
  gray100: '#262626',
  gray200: '#333333',
  gray300: '#404040',
  gray400: '#555555',
  gray500: '#737373',
  gray600: '#a0a0a0',
  gray700: '#c0c0c0',
  gray800: '#e0e0e0',
  gray900: '#f5f5f5',

  // Input
  inputDisabled: '#2a2a2a',
};
